function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Share_ic"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 129.18,
  cy: 138.12,
  r: 17.88
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.88,
  cy: 80,
  r: 17.88
}), /*#__PURE__*/React.createElement("circle", {
  cx: 138.12,
  cy: 21.88,
  r: 17.88
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.63 88.48l75.82 41.11M122.12 29.89L37.9 72.04"
}));

var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "ICON",
    viewBox: "0 0 160 160",
    "aria-hidden": true
  }, props), _ref);
};

export default SvgShare;